export enum InstallmentTypeEnum {
  Vivienda2019 = 1,
  Comercial = 2,
  Vivienda2023 = 3,
  Vivienda2024 = 4,
}
